import type { Messages } from './en';

/** Contingut de la fase 1: xat del Papa, pràctica d’anglès, notícies de la tele, seguretat a les xarxes. */
export const caExtra: Pick<Messages, 'dadChat' | 'english2' | 'news' | 'social'> = {
  dadChat: {
    name: 'Papa 👔',
    preview: 'El Papa ha enviat una imatge',
    cards: [
      { big: 'Bon dia', sub: 'Somriu avui, i el món et somriurà' },
      { big: 'Pau i alegria', sub: 'Et desitjo salut i molta sort' },
      { big: 'Feliç divendres', sub: 'Treballa fort, descansa bé' },
      { big: 'Bon cap de setmana', sub: 'La família és el tresor més gran' },
      { big: 'Bona nit', sub: 'Descansa bé i somnis dolços' },
      { big: 'Salut!', sub: 'Beu aigua i camina sovint' },
      { big: 'Benediccions', sub: 'Que tot et vagi rodó' },
      { big: 'Bon dia', sub: 'Un dia nou, una esperança nova' },
    ],
    cardCaption: ['🌸 Per a la meva estimada família!', '☀️ Bon dia a tothom!', '🙏 Que tinguis molta sort!', '💪 Endavant!'],
    choices: {
      thanks: 'Gràcies, Papa! ❤️',
      cardBack: 'Enviar-li una postal de resposta 🌻',
      askDay: 'Com va la feina avui, Papa?',
      photo: 'Enviar al Papa una foto d’avui 📸',
    },
    replies: {
      thanks: ['De res! El Papa t’estima!', 'Hi hi, el Papa està content que t’hagi agradat!', 'Recorda menjar-te la verdura! 🥦'],
      cardBack: ['Uau! Que bonica! On l’has trobat? 😄', 'El Papa l’ha desat! Ara l’he d’enviar a l’avi també.', 'Dues postals en un dia! Quina sort!'],
      askDay: ['Molta feina, però el teu missatge ho millora!', 'Moltes reunions… penso en el sopar amb vosaltres.', 'El cap m’ha dit que avui ho he fet molt bé! 💪'],
      photo: ['Quina foto més bona! Ets tot un fotògraf!', 'Sembla un dia divertit. Vés amb compte, eh!', 'El Papa l’ha posat de fons de pantalla del mòbil!'],
    },
    rumors: [
      {
        text: '⚠️ URGENT!! Reenvia això a 10 persones o demà se’t bloquejarà el mòbil!!!',
        correct: 'Papa, això és un missatge en cadena. Els mòbils no es bloquegen així 😊',
        share: 'D’acord, el reenvio!',
        dadOk: 'Oh! De debò? Gràcies per dir-m’ho. No el reenviaré.',
        dadBad: 'Perfecte, ja l’he enviat a 30 persones! 😅',
        lesson: 'Els missatges en cadena que amenacen amb mala sort sempre són falsos. No els reenviïs.',
      },
      {
        text: 'Un metge diu: beure aigua calenta amb llimona cada hora cura tots els virus! Comparteix-ho amb tothom!',
        correct: 'Papa, mirem primer una web de salut de confiança. Una beguda no pot curar tots els virus.',
        share: 'Uau, ho diré als meus amics!',
        dadOk: 'Tens raó, no he mirat d’on venia. Quin nen més espavilat!',
        dadBad: 'Sí! Faré aigua amb llimona per a tota l’oficina!',
        lesson: 'Les «cures miraculoses» s’escampen molt de pressa. Consulta fonts oficials i pregunta a un metge.',
      },
      {
        text: 'Gratis! Fes clic en aquest enllaç per rebre 5000 NT$ del govern. Només has de posar la teva targeta bancària!',
        correct: 'Papa, no hi facis clic! El govern mai no et demana la targeta per missatge.',
        share: 'Diners gratis? Fem-hi clic!',
        dadOk: 'Sort que m’ho has dit. L’esborro ara mateix.',
        dadBad: 'Hmm, la pàgina em demana la contrasenya… que estrany.',
        lesson: 'Les oficines de veritat mai no demanen números de targeta ni contrasenyes per missatge. És pesca (phishing).',
      },
    ],
    rumorPrompt: 'El Papa ha reenviat un missatge:',
  },

  english2: {
    title: '📚 Racó d’anglès',
    tabs: { learn: 'Aprendre', review: 'Repassar', spell: 'Lletrejar', talk: 'Parlar', read: 'Llegir' },
    learnHint: 'Toca una paraula per sentir-la. Quan la practiques, s’afegeix a la teva llista de repàs.',
    reviewHint: 'Pensa la paraula en anglès i després descobreix-la.',
    reviewNone: 'Ara no hi ha res per repassar. Molt bé! Primer aprèn paraules noves.',
    reviewDue: (n: number) => `${n} paraul${n === 1 ? 'a' : 'es'} per repassar`,
    show: 'Mostrar la resposta',
    knew: '✅ La sabia',
    again: '🔁 Una altra vegada',
    choose: 'Quina paraula vol dir això?',
    spellHint: 'Escolta i després toca les lletres en ordre.',
    spellOk: 'Ortografia perfecta!',
    spellBad: 'No del tot. Torna-ho a provar!',
    undo: '⌫',
    hear: '🔊 Escoltar',
    next: 'Següent ➜',
    talkHint: 'Tria la millor resposta en anglès. Escolta cada frase!',
    talkPick: 'Tria una situació:',
    talkGood: 'Molt bona resposta!',
    talkBad: 'Hmm, aquesta no encaixa. Prova’n una altra.',
    talkDone: (title: string) => `Conversa completada: ${title}`,
    hereFirst: '📍 Aquí',
    mastered: (n: number, total: number) => `Dominades ${n}/${total}`,
    categories: {
      school: 'Institut', library: 'Biblioteca', food: 'Menjar i cafeteria', shopping: 'Compres', sports: 'Esports',
      health: 'Salut', home: 'Casa', feelings: 'Sentiments', safety: 'Seguretat a internet', nature: 'Natura',
    },
    scenarios: {
      cafe: 'Demanar una beguda en una cafeteria',
      library: 'Agafar un llibre en préstec',
      store: 'Comprar un piscolabis a la botiga',
      nurse: 'Explicar a la infermera com et trobes',
      directions: 'Preguntar com anar a un lloc',
      newFriend: 'Presentar-te a un amic nou',
      restaurant: 'Demanar el sopar en un restaurant',
      sports: 'Apuntar-te a un entrenament',
      gift: 'Triar un regal d’aniversari',
      phone: 'Respondre una trucada amb educació',
    },
    meanings: {
      classroom: 'aula', homework: 'deures', teacher: 'professor/a', pencil: 'llapis', eraser: 'goma d’esborrar', schedule: 'horari',
      borrow: 'agafar en préstec', return: 'tornar', quiet: 'silenciós', novel: 'novel·la', dictionary: 'diccionari', shelf: 'prestatge',
      menu: 'menú, carta', order: 'demanar', delicious: 'deliciós', thirsty: 'assedegat, tenir set', bill: 'el compte', breakfast: 'esmorzar',
      price: 'preu', cheap: 'barat', expensive: 'car', receipt: 'tiquet', discount: 'descompte', cashier: 'caixer/a',
      team: 'equip', practice: 'entrenament, pràctica', score: 'puntuació', swim: 'nedar', racket: 'raqueta', referee: 'àrbitre',
      fever: 'febre', headache: 'mal de cap', medicine: 'medicament', rest: 'descans', nurse: 'infermer/a', bandage: 'bena',
      kitchen: 'cuina', laundry: 'bugada', chores: 'feines de casa', neighbor: 'veí/veïna', family: 'família', dinner: 'sopar',
      nervous: 'nerviós', proud: 'orgullós', grateful: 'agraït', lonely: 'sol, que se sent sol', excited: 'emocionat', calm: 'tranquil',
      password: 'contrasenya', privacy: 'privacitat', stranger: 'desconegut', report: 'denunciar, informar', block: 'bloquejar', scam: 'estafa',
      blossom: 'flor (d’arbre)', pond: 'estany', breeze: 'brisa', butterfly: 'papallona', sunset: 'posta de sol', puddle: 'bassal',
    },
  },

  news: {
    title: '📺 Notícies del Barri 24',
    live: 'EN DIRECTE',
    anchor: 'Presentadora',
    quiz: 'Notícia real o falsa?',
    real: '✅ Real',
    fake: '❌ Falsa',
    right: 'Correcte!',
    wrong: 'No del tot!',
    nextStory: 'Següent notícia ▶',
    done: 'Això és tot per avui. Gràcies per mirar-nos!',
    ticker: 'Temps: sol i una brisa suau · Recorda: comprova la font abans de compartir ·',
    stories: [
      { head: 'Els cirerers floreixen abans d’hora al parc del barri', body: 'El bon temps ha fet florir els cirerers una setmana abans. Les famílies fan pícnics sota els arbres rosats.', real: true, why: 'Ve de l’equip de notícies local, amb fotos i data. Una notícia normal i comprovable.' },
      { head: 'Increïble! Menjar xocolata et fa créixer 10 cm en una setmana!', body: 'Un vídeo a internet diu que una «dieta secreta de xocolata» fa que els nens creixin en una nit.', real: false, why: 'Promeses exagerades, cap metge amb nom i un truc «secret»: senyals típics de notícia falsa.' },
      { head: 'La biblioteca de l’institut estrena 500 llibres nous', body: 'La biblioteca ha rebut còmics, novel·les i llibres de ciència gràcies a una venda solidària.', real: true, why: 'Fets concrets i normals que l’institut pot confirmar.' },
      { head: 'Un famós regala mòbils gratis: només cal compartir aquesta publicació!', body: 'Una publicació diu que un cantant famós enviarà un mòbil a tothom qui comparteixi i comenti.', real: false, why: 'Els sortejos que et demanen compartir són estafes per aconseguir interacció. Les marques de veritat ho anuncien a les pàgines oficials.' },
      { head: 'L’horari de la línia 8 d’autobús canvia el mes que ve', body: 'L’ajuntament ha anunciat que els autobusos passaran cada 10 minuts en horari escolar.', real: true, why: 'Ho anuncia l’oficina de transport de la ciutat: ho pots comprovar al seu web.' },
      { head: 'Els científics diuen que aquesta nit la lluna es tornarà verda', body: 'Un missatge viral diu que sortirà una estranya lluna verda per primer cop en 1000 anys.', real: false, why: 'No diu el nom de cap científic ni observatori, i juga amb l’emoció. Consulta una web d’astronomia.' },
      { head: 'La policia avisa de missatges falsos de paquets', body: 'Els missatges que diuen «el teu paquet t’espera, paga aquí» són una estafa nova. No obris els enllaços.', real: true, why: 'És un avís oficial, i un bon consell: no paguis mai a través d’un enllaç d’un missatge.' },
      { head: 'Beure refresc de cola cura el refredat, diu un expert anònim', body: 'Un missatge en cadena diu que la cola va millor que els medicaments per al refredat.', real: false, why: '«Expert anònim» és un senyal d’alerta. Els consells mèdics han de venir de metges de veritat.' },
      { head: 'L’estany del parc estrena nenúfars i peixos', body: 'Uns voluntaris han plantat nenúfars i han deixat anar peixos de la zona perquè l’estany estigui sa.', real: true, why: 'Un acte local amb voluntaris amb nom i fotos.' },
    ],
  },

  social: {
    snapshot: '📸 Fer una foto',
    upload: '🖼️ Pujar una foto',
    captionTitle: 'Afegeix un text',
    captions: ['Quin dia més bonic! ☀️', 'Mireu el meu berenar 🍙', 'Amb els meus amics 💛', 'La meva mascota és superbufona 🐰', 'Hora d’estudiar 📚'],
    posted: 'Publicat! Els teus amics ho veuran.',
    likes: (n: number) => `❤️ ${n}`,
    comments: 'Comentaris',
    writeComment: 'Comentar',
    you: 'Tu',
    friendComments: {
      0: ['Que bonic! 😍', 'On és això?', 'Quin temps més perfecte!'],
      1: ['Mmm! Guarda-me’n un!', 'Ara tinc gana 😂', 'Fa molt bona pinta!'],
      2: ['Us trobo a faltar!', 'Millors amics! 💛', 'La pròxima vegada convideu-me!'],
      3: ['Que bufó!! 🥰', 'Com es diu?', 'Jo també vull una mascota!'],
      4: ['Que treballador/a! 💪', 'Estudiem junts?', 'Molta sort a l’examen!'],
    } as Record<number, string[]>,
    replyOptions: ['Gràcies! 😊', 'Ha ha, sí!', 'La pròxima vegada hi anem junts!'],
    replies: {
      question: ['Bona pregunta! Crec que sí 🤔', 'Hmm, ho pregunto a la meva mare i t’ho dic!', 'Sí! Vols venir la pròxima vegada?'],
      thanks: ['De res! 🥰', 'Quan vulguis! 💛', 'Cap problema!'],
      laugh: ['Ha ha ha, jo igual 😂', 'Para, que estic rient a classe! 🤣', 'Ha ha ha!'],
      love: ['Ooh, jo també t’estimo! 💖', 'Ets el millor! 🥰', 'Amics per sempre!'],
      food: ['Ara tinc gana 🤤', 'Guarda-me’n un mos!', 'Fa una pinta boníssima!'],
      plan: ['Sí! Fem-ho aquest cap de setmana!', 'Compta amb mi! 🙌', 'Primer ho pregunto als meus pares!'],
      sad: ['Oh, no, estàs bé? 🫂', 'Vols que en parlem després? Sóc aquí.', 'T’envio una abraçada enorme!'],
      generic: ['Que guai! 😊', 'Totalment d’acord!', 'Ha ha, que divertit que ets!', 'Genial! ✨'],
    },
    friendNames: ['Rain', 'Emma', 'Jay', 'Ming'],
    lessonTitle: '🛡️ Què hem après?',
    cases: {
      fakeFriend: {
        author: '«Mia, 13 ✨»',
        tag: '⚠️ Sol·licitud d’amistat',
        content: 'Hola!! Sembles molt guai! Sóc nova aquí. Podem xatejar en privat? A quin institut vas? 🥺',
        safe: 'No dir res i preguntar primer als pares',
        risky: 'Dir-li el meu institut i la meva classe',
        safeMsg: 'Molt bé. No pots saber qui hi ha realment darrere d’un perfil. No diguis mai el teu institut, la teva adreça ni els teus horaris.',
        riskyMsg: 'Compte! Els perfils poden ser falsos: de vegades hi ha adults que es fan passar per nens. Guarda la teva informació personal.',
        lesson: 'Si un «amic» nou d’internet et fa moltes preguntes personals de seguida, és un senyal d’alerta. Parla-ho amb un adult de confiança.',
      },
      romance: {
        author: '«Leo 💕»',
        tag: '⚠️ Missatge',
        content: 'Crec que m’agrades molt. Ets especial. No els diguis res als teus pares de nosaltres, d’acord? Em podries comprar una targeta regal?',
        safe: 'Bloquejar-lo i dir-ho a un adult de confiança',
        risky: 'Guardar el secret i comprar la targeta',
        safeMsg: 'Exacte. Que et demanin guardar secrets als pares i que et demanin diners són senyals d’alerta molt grossos.',
        riskyMsg: 'Això és un engany que es diu grooming o estafa amorosa. Algú que t’estima de veritat no et demanaria secrets ni diners.',
        lesson: '«No els ho diguis als teus pares» + «envia’m diners o regals» = para, bloqueja i explica-ho a un adult. Mai no és culpa teva.',
      },
      privatePhoto: {
        author: '«Caçatalents ⭐»',
        tag: '⚠️ Petició',
        content: 'Podries ser model! Envia’m fotos privades teves, només per a mi. Et faré famós!',
        safe: 'No enviar-ne mai: bloquejar, denunciar i dir-ho a un adult',
        risky: 'Enviar una foto per fer-me famós',
        safeMsg: 'Perfecte. No enviïs mai fotos privades a ningú per internet. Bloqueja, denuncia i explica-ho als pares o a un professor.',
        riskyMsg: 'Para! Les fotos es poden copiar i fer servir per fer-te mal o amenaçar-te. Explica-ho de seguida a un adult de confiança: no et renyarà.',
        lesson: 'Els caçatalents de veritat mai no demanen fotos privades als nens. Si algú ho fa, o t’amenaça, explica-ho a un adult i denuncia-ho.',
      },
      fakeNews: {
        author: 'Pàgina «Secrets de Salut 100%»',
        tag: '⚠️ Publicació viral',
        content: 'COMPARTEIX-HO JA!!! Menjar 10 llimones al dia atura TOTES les malalties! Els metges odien aquest truc!!!',
        safe: 'Comprovar una font fiable abans de compartir',
        risky: 'Compartir-ho amb tothom',
        safeMsg: 'Molt espavilat! Comprova fonts de confiança (metges, webs oficials de salut) abans de compartir.',
        riskyMsg: 'Compartir consells de salut falsos pot fer mal a la gent. «Els metges odien aquest truc» és una frase típica de notícia falsa.',
        lesson: 'Pregunta’t: qui ho ha escrit? Hi ha proves? Les fonts de confiança diuen el mateix? Si no, no ho comparteixis.',
      },
      phishing: {
        author: '«Seguretat PixelBook»',
        tag: '⚠️ Missatge',
        content: 'El teu compte s’ESBORRARÀ d’aquí a 1 hora! Inicia sessió aquí per conservar-lo: pixe1book-login.co',
        safe: 'Ignorar-lo i denunciar el missatge',
        risky: 'Fer-hi clic i iniciar sessió ràpid',
        safeMsg: 'Molt bé! Fixa-t’hi: «pixe1book» porta un número 1. Les plataformes de veritat no t’amenacen així.',
        riskyMsg: 'Era una pàgina d’inici de sessió falsa per robar-te la contrasenya. Canvia la contrasenya i explica-ho a un adult.',
        lesson: 'Amenaces urgents + enllaços estranys = pesca (phishing). Obre tu mateix l’aplicació de veritat en lloc de fer clic.',
      },
      easyMoney: {
        author: '«Agència Feina Fàcil»',
        tag: '⚠️ Oferta de feina',
        content: 'Estudiants: guanyeu 3000 NT$ al dia des de casa! Només ens heu de deixar el vostre compte bancari i el número de mòbil.',
        safe: 'Dir que no i explicar-ho a un adult',
        risky: 'Sona genial, els envio el meu compte',
        safeMsg: 'Molt bona decisió. Si deixes el teu compte, et poden fer part d’un delicte sense que te n’adonis.',
        riskyMsg: 'Els estafadors fan servir els comptes dels nens per moure diners robats. No deixis mai comptes, targetes ni números de mòbil.',
        lesson: 'Si una feina sembla massa fàcil per ser veritat, és una estafa. No comparteixis mai les dades del banc.',
      },
    },
  },
};
